import { frfwProxy } from '../request';

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // 申请证书
    async applyCert({ dispatch, rootState }, data = {}) {
      const orderId = rootState.frfwScan.orderId;
      return frfwProxy.request({
        url: '/frfw/cert/applyCert',
        method: 'post',
        data: {
          orderId,
        },
      });
    },
    // 获取订单号
    async getOrderId({ dispatch, rootState }, data = {}) {
      return frfwProxy.request({
        url: '/frfw/sheca/certOrder',
        method: 'post',
      });
    },
    // 查询证书是否存在
    async isExistCerts(options, data = {}) {
      return frfwProxy.request({
        url: '/frfw/cert/isexist',
        method: 'post',
        data,
      });
    },
    async redirectPage({ dispatch, rootState }, data = {}) {
      const orderId = rootState.frfwScan.orderId;
      return frfwProxy.request({
        url: '/frfw/cert/getOrder',
        method: 'post',
        data: {
          orderId,
        },
      });
    },
  },
};
